var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 31,
    viewBox: "0 0 22 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 8.04736V11.0474H9.25C8.7325 11.0474 8.5 11.6549 8.5 12.1724V14.0474H10.75V17.0474H8.5V23.0474H5.5V17.0474H3.25V14.0474H5.5V11.0474C5.5 10.2517 5.81607 9.48865 6.37868 8.92604C6.94129 8.36343 7.70435 8.04736 8.5 8.04736H10.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e296c57821ae90cc945eb72505330f5d.svg";
export { ForwardRef as ReactComponent };